import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ Children: ReactComponent, isAdminRoute }) => {
  const token = localStorage.getItem("token") || "";
  const user = localStorage.getItem("user") || "";
  const agent_token = localStorage.getItem("agent_token");
  const agent_user = localStorage.getItem("agent_user");
  if (isAdminRoute == true) {
    return agent_token && agent_user ? (
      <ReactComponent authUser={true} />
    ) : (
      <Navigate to="/" />
    );
  } else {
    return token && user ? (
      <ReactComponent authUser={true} />
    ) : (
      <Navigate to="/" />
    );
  }
};
export default PrivateRoute;
